import React from 'react';
import './BathroomSharing.css';

interface Props {
  /** Nombre de colocataires partageant la salle de bain. 0 = privative. */
  value: number | null;
  onChange: (valeur: number) => void;
  id?: string;
}

/**
 * Salle de bain : privative ou partagée.
 *
 * Le champ était un simple nombre où 0 signifiait « privative » — une
 * convention que rien n'annonçait. Deux boutons radio disent la question, et le
 * nombre n'apparaît que dans le cas où il veut dire quelque chose.
 *
 * Composant UNIQUE : le wizard et l'écran Chambres l'utilisent tous les deux.
 */
const BathroomSharing: React.FC<Props> = ({ value, onChange, id = 'sdb' }) => {
  const partagee = value != null && value > 0;

  return (
    <div className="sdb">
      <span className="sdb-libelle">Salle de bain *</span>
      <div className="sdb-choix">
        <label>
          <input
            type="radio"
            name={`${id}-partage`}
            checked={value === 0}
            onChange={() => onChange(0)}
          />
          Privative
        </label>
        <label>
          <input
            type="radio"
            name={`${id}-partage`}
            checked={partagee}
            // 1 par défaut à la bascule : la valeur reste modifiable juste à
            // côté, et « partagée avec 0 personne » serait contradictoire.
            onChange={() => onChange(value && value > 0 ? value : 1)}
          />
          Partagée
        </label>
      </div>
      {partagee && (
        <label className="sdb-nombre">
          Avec combien de colocataires&nbsp;?
          <input
            type="number"
            min={1}
            value={value ?? 1}
            onChange={(e) => onChange(Math.max(1, parseInt(e.target.value, 10) || 1))}
          />
        </label>
      )}
      <small className="sdb-aide">
        Affiché sur la page publique de la chambre : « SdB privée » ou
        « SdB partagée&nbsp;({value || 1}) ».
      </small>
    </div>
  );
};

export default BathroomSharing;
